<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="true"
      @handleBtn="handleBtn"
    ></page-head>

    <div class="content">
      <div class="wrapper">
        <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="所属区域">
                <template v-if="isEdit">
                  <Cascader
                    v-model="comList"
                    :data="communityList"
                    placeholder="请选择"
                    clearable
                    @on-change="communityChange"
                    change-on-select
                  ></Cascader>
                </template>
                <template v-else>
                  <div class="detail">{{ info.communityName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="批次">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.batchNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.batchNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="运营商">
                <template v-if="isEdit">
                  <Select v-model="info.carrier" clearable>
                    <Option
                      v-for="item in carrierList"
                      :key="item.type"
                      :value="item.type"
                      :label="item.name"
                    ></Option>
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">{{ carrierMap[info.carrier] }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="姓名">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.userName"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.userName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="手机号">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.phoneNO" disabled></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.phoneNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="证件号码">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.idCardNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.idCardNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="离濮时间">
                <template v-if="isEdit">
                  <DatePicker
                    v-model="leaveTime"
                    type="datetime"
                    class="time"
                    placeholder="请选择离濮时间"
                  ></DatePicker>
                </template>
                <template v-else>
                  <div class="detail">{{ info.leaveTime }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="返濮时间">
                <template v-if="isEdit">
                  <DatePicker
                    type="datetime"
                    v-model="returnTime"
                    class="time"
                    placeholder="请选择返濮时间"
                  ></DatePicker>
                </template>
                <template v-else>
                  <div class="detail">{{ info.returnTime }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="外出地">
                <template v-if="isEdit">
                  <!-- <Cascader
                    v-model="fromWhereList"
                    :data="areadata"
                    :load-data="getArea"
                    placeholder="请选择"
                    clearable
                    @on-change="fromWhereChange"
                    change-on-select
                  ></Cascader> -->
                  <Input
                    v-model="info.leaveAddress"
                    clearable
                    placeholder="请输入外出地"
                  />
                </template>
                <template v-else>
                  <div class="detail">{{ info.leaveAddress }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="是否在濮">
                <template v-if="isEdit">
                  <Select v-model="info.isHere" clearable>
                    <Option
                      v-for="item in dicList"
                      :key="item.type"
                      :value="item.type"
                      :label="item.name"
                    ></Option>
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">{{ dicMap[info.isHere] }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="目前所在地">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.currentAddress"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.currentAddress }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="是否隔离">
                <template v-if="isEdit">
                  <Select v-model="info.isQuarantine" clearable>
                    <Option
                      v-for="item in dicList"
                      :key="item.type"
                      :value="item.type"
                      :label="item.name"
                    ></Option>
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">{{ dicMap[info.isQuarantine] }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="隔离地点">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.quarantineAddress"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.quarantineAddress }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="隔离方式">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.quarantineType"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.quarantineType }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="是否核酸检测">
                <template v-if="isEdit">
                  <Select v-model="info.isCheck" clearable>
                    <Option
                      v-for="item in dicList"
                      :key="item.type"
                      :value="item.type"
                      :label="item.name"
                    ></Option>
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">{{ dicMap[info.isCheck] }}</div>
                </template>
              </FormItem>
            </i-col>
            <!-- <i-col span="8">
              <FormItem label="最后一次核酸检测时间">
                <template v-if="isEdit">
                  <DatePicker
                    type="datetime"
                    v-model="lastCheckTime"
                    class="time"
                    placeholder="请选择最后检测时间"
                  ></DatePicker>
                </template>
                <template v-else>
                  <div class="detail">{{ info.lastCheckTime }}</div>
                </template>
              </FormItem>
            </i-col> -->
            <i-col span="8">
              <FormItem label="检测结果">
                <template v-if="isEdit">
                  <Select v-model="info.checkResult" clearable>
                    <Option
                      v-for="item in resultList"
                      :key="item.type"
                      :value="item.type"
                      :label="item.name"
                    ></Option>
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">{{ resultMap[info.checkResult] }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="24">
              <FormItem
                label="核查情况（较为详细的情况，如未隔离或未作核酸检测，写清下一步管控措施）"
              >
                <template v-if="isEdit">
                  <Input
                    v-model="info.checkMsg"
                    size="large"
                    placeholder="请输入核查情况"
                    type="textarea"
                    :rows="6"
                    :maxlength="1000"
                  />
                </template>
                <template v-else>
                  <div class="detail">{{ info.checkMsg }}</div>
                </template>
              </FormItem>
            </i-col>
          </row>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { getPersonInspectionById, addPersonInspection } = api;
export default {
  name: "personInspectionDetail",
  components: {
    pageHead,
  },
  data() {
    return {
      title: "重点人员排查信息详情",
      btnList: [
        {
          name: "编辑",
          type: "edit",
          loading: false,
        },
      ],
      dicList: [
        {
          name: "是",
          type: 1,
        },
        {
          name: "否",
          type: 0,
        },
      ],
      carrierList: [
        {
          name: "移动",
          type: 1,
        },
        {
          name: "联通",
          type: 2,
        },
        {
          name: "电信",
          type: 3,
        },
        {
          name: "其他",
          type: 0,
        },
      ],
      dicMap: ["否", "是"],
      resultMap: ["阴性", "阳性", "未出结果"],
      carrierMap: ["其他", "移动", "联通", "电信"],
      resultList: [
        {
          name: "阳性",
          type: 1,
        },
        {
          name: "阴性",
          type: 0,
        },
        {
          name: "未出结果",
          type: 2,
        },
      ],
      savedId: "",
      isEdit: false,
      leaveTime: "",
      returnTime: "",
      lastCheckTime: "",
      fromWhereList: [],
      comList: [], // 回显list
      communityList: [], // 数据源list
      communityId: "", // 选中的commuId
      areadata: [], //全国行政区域
      info: {},
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "edit") {
        if (!this.isEdit) {
          this.isEdit = true;
          console.log("edit");
          this.$set(this.btnList[0], "name", "保存");
        } else {
          this.saveInfo();
        }
      }
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: item.communityId,
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    //获取行政区域
    getArea(item, callback) {
      item.loading = true;
      this.$post(this.urlobj.getArea + "id=" + item.id)
        .then((res) => {
          let data = res.map((_item) => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              value: _item.path,
              label: _item.text,
              level: item.level + 1,
            };
            if (item.level != 2) {
              resturn_data.children = [];
              resturn_data.loading = false;
            }

            return resturn_data;
          });
          if (item.level == 0) {
            this.areadata = data;
          } else {
            item.loading = false;
            item.children = data;
            callback();
          }
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    fromWhereChange(value) {
      this.info.leaveAddress = value[value.length - 1];
      //   console.log( this.info.leaveAddress)
      //   this.initFangyiList();
    },
    communityChange(value) {
      this.communityId = value[value.length - 1];
      console.log(this.communityId);
    },
    saveInfo() {
      console.log(this.info);
      if (!this.comList || isNaN(this.comList[0]))
        return this.$Message.error("请选择所属区域");
      this.info.leaveTime = this.leaveTime
        ? this.$util.FormatDate(new Date(this.leaveTime), "yyyy-MM-dd HH:mm:ss")
        : "";
      this.info.returnTime = this.returnTime
        ? this.$util.FormatDate(
            new Date(this.returnTime),
            "yyyy-MM-dd HH:mm:ss"
          )
        : "";
      this.info.lastCheckTime = this.lastCheckTime
        ? this.$util.FormatDate(
            new Date(this.lastCheckTime),
            "yyyy-MM-dd HH:mm:ss"
          )
        : "";
      this.info.communityPath =
        "100000000000.410000000000." + this.comList.join(".");
      this.info.communityId =
        this.communityId ||
        this.info.communityPath.slice(
          this.info.communityPath.lastIndexOf(".") + 1
        );

      this.btnList[0].loading = true;
      this.$post(addPersonInspection, this.info)
        .then((res) => {
          this.btnList[0].loading = false;
          this.$Message.success("提交成功");
          this.$set(this.btnList[0], "name", "编辑");
          this.isEdit = false;
          this.savedId = res.newPrimaryKeys.id;
          this.getDetail();
        })
        .catch((e) => {
          this.btnList[0].loading = false;
          // this.$Message.error("提交失败");
        });
    },
    async getDetail() {
      try {
        let { id } = this.$route.query;
        console.log(id);
        let res = await this.$get(getPersonInspectionById(id));
        if (!id && !this.savedId) {
          // this.savedId
          this.isEdit = true;
          this.$set(this.btnList1[0], "name", "保存");
          return;
        }
        if (res.isSucceed && res.rows) {
          console.log(res);
          this.info = res.rows[0];
          this.leaveTime = this.info.leaveTime;
          this.returnTime = this.info.returnTime;
          this.lastCheckTime = this.info.lastCheckTime;
          this.comList = this.info.communityPath.split(".").map((item) => {
            return parseInt(item);
          });
          this.comList && this.comList.splice(0, 2);
          console.log(this.info);
          console.log(this.comList);
        }
      } finally {
      }
    },
  },
  created() {
    this.getCommunity();
    // this.getArea({ id: "100000000000", level: 0 });
    this.getDetail();
  },
};
</script>

<style  scoped lang="less">
.content {
  margin: 0 20px;
}

.wrapper {
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.detail {
  color: #666;
}

.time {
  width: 100%;
}
</style>